<template>
  <div id="down" ref="element">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%;box-shadow: 0px 0px 1px 1px gray;"></div>
    <!--轮播-->
    <div class="block">
      <el-row class="join">
        <el-col :span="18" :offset="3" style="text-align: left;height: 200px;border: solid 1px cornflowerblue;padding: 30px">
          <p>贵州快点在线科技有限公司立志做打印行业领军者，欢迎志同道合的你加入我们。成为我们的校园合伙人</p>
          <p style="margin: 15px 0px"> 联系方式：</p>
          <p style="padding-left: 60px">邮箱：kuaidian@kdslow.com </p>
          <p style="padding-left: 60px">电话：15685145762 </p>
        </el-col>
        <el-col :span="18" :offset="3" style="text-align: center;margin-top: 10px">
          <img style="height: 40px" src="@/assets/images/join.png">
        </el-col>
        <el-col :span="18" :offset="3" style="text-align: center;margin-top: 10px">
          <p>{{info}}</p>
          <el-col style="font-size: 1.2rem;margin-top: 1rem">
            请致电：15685145762（微信同号）
<!--            <el-form v-loading="isloading" style="margin-top: 20px" :inline="true" :model="form" class="demo-form-inline">-->
<!--              <el-form-item>-->
<!--                <el-input v-model="form.name" maxlength="20" placeholder="姓名"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-input v-model="form.phone" maxlength="11" minlength="11" placeholder="联系电话"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item>-->
<!--                <el-button type="primary" @click="onSubmit">提交</el-button>-->
<!--              </el-form-item>-->
<!--            </el-form>-->
          </el-col>
        </el-col>
        <el-col :span="18" :offset="3" style="text-align: center;margin-top: 50px">
          <el-col :span="24"><p  style="font-family: Sakkal Majalla;font-size: 20px">合作机构</p></el-col>
          <el-col :span="24" style="display: flex;justify-content: start;flex-wrap: wrap">
            <div v-for="(item,index) in schools" :key="index" style="text-align: center;margin:1rem 1.5rem;">
              <img style="border-radius: 50%;width: 6rem;height: 6rem;margin: 25px auto;" :src="'http://ad.kdslow.com/api/'+item.icon"/>
              <p style="width: 6rem">{{item.title}}</p>
            </div>
          </el-col>
<!--          <el-col :span="3"  v-for="(item,index) in schools" :key="index" style="text-align: center;padding:1rem">-->
<!--            <img style="border-radius: 50%;width: 100%;margin: 25px auto;" :src="'http://admin.partner.kdslow.com/api/'+item.icon"/>-->
<!--            <span>{{item.title}}</span>-->
<!--          </el-col>-->
        </el-col>
      </el-row>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      schools: [],
      isloading: false,
      form: {},
      info: '如果您认同我们的发展理念，如果您有学校相关资源，如果您有其他一技之长，那么，我们需要你！'
    }
  },
  created () {
    Api.changeClass = 5
    this.getInfo()
    this.getSchoolList()
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    onSubmit () {
      if (!this.form.name) return
      if (!this.form.phone) return
      let formData = new FormData()
      formData.append('name', this.form.name)
      formData.append('phone', this.form.phone)
      let _this = this
      this.isloading = true
      axios({url: Api.Market_BASE_URL + Api.addConnect,
        method: 'post',
        data: formData
      }).then((response) => {
        _this.isloading = false
        console.log(response)
        if (response.data.code === 0) {
          _this.form = {}
          window.bus.$message({
            message: '提交成功',
            type: 'success'
          })
        }
      }, (response) => {
        _this.isloading = false
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    },
    getSchoolList () {
      let _this = this
      axios.get(Api.Market_BASE_URL + Api.getSchoolList).then((response) => {
        console.log(response)
        _this.schools = response.data.data
        console.log(_this.schools)
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    },
    getInfo () {
      let _this = this
      axios.get(Api.Market_BASE_URL + Api.getInfo + '?keyname=join').then((response) => {
        console.log(response)
        _this.info = response.data.data.valuestr
      }, (response) => {
        console.log('请求超时，请检查网络' + response)
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style>
  .join{
    margin: 50px 0px;
    /*min-height: 660px;*/
  }

  .nav-content {
    width: 100%;
    height: 80px;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .news-gj {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .news-banner {
    width: 100%;
    height: 550px;
  }

  .news-banner img {
    width: 100%;
    height: 550px;
  }

  .main {
    width: 1200px;
  }

  .news-title {
    width: 100%;
    height: 55px;
    line-height: 55px;
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    background-color: #f62828;
    box-shadow: 3px 5px 10px -2px rgba(0, 0, 0, 0.3),
    -3px -5px 10px -2px rgba(0, 0, 0, 0.3);
    position: relative;
    top: 10px;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }

  .news-block {
    border: 1px solid #ddd;
    height: 350px;
    margin-bottom: 30px;
  }

  .news-block a:hover h3, .news-block a:hover p {
    color: #f62828;
  }

  .news-img {
    width: 100%;
    height: 210px;
  }

  .news-text {
    padding: 10px;
    text-align: left;
  }

  .news-text h3 {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    line-height: 30px;
  }

  .news-text p {
    font-size: 14px;
    color: #555;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -moz-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .news-text span {
    color: #f62828;
    line-height: 30px;
  }

  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }

</style>



// WEBPACK FOOTER //
// src/components/JoinUs.vue